export type VisitScheduleDuplicateCheckEvent = {
  id: string | number;
  patient_id?: number;
  massager_id?: number;
  visit_datetime_from?: string;
};

export type SamePatientSameDayDuplicateType = 'same_massager' | 'other_massager';

export function excludePendingDeletedVisits<T extends VisitScheduleDuplicateCheckEvent>(
  events: T[],
  pendingDeletedVisitIds: number[] = []
): T[] {
  if (pendingDeletedVisitIds.length === 0) {
    return events;
  }

  const deletedIds = new Set(pendingDeletedVisitIds);
  return events.filter(event => typeof event.id !== 'number' || !deletedIds.has(event.id));
}

export function getSamePatientSameDayDuplicateType({
  events,
  editingId,
  patientId,
  currentMassagerId,
  visitDate,
}: {
  events: VisitScheduleDuplicateCheckEvent[];
  editingId?: string | number | null;
  patientId: number;
  currentMassagerId: number | null | undefined;
  visitDate: string;
}): SamePatientSameDayDuplicateType | null {
  const sameDayEvents = events.filter(event => {
    if (editingId != null && event.id === editingId) return false;
    return (
      event.patient_id === patientId &&
      (event.visit_datetime_from ?? '').slice(0, 10) === visitDate
    );
  });

  if (sameDayEvents.some(event => event.massager_id === currentMassagerId)) {
    return 'same_massager';
  }

  return sameDayEvents.length > 0 ? 'other_massager' : null;
}
